import classNames from 'classnames'
import styles from './ItemRow.module.scss'
import { type ItemRowBodyProps } from './types'
import { getImageUrl } from '@/tools/image-service'
import { ListItem, Thumbnail, ThumbnailRatio } from '@/tools/ui'

export const ItemRowBody: React.FC<ItemRowBodyProps> = ({
  description,
  imgAlt,
  size,
  imgSrc,
  price,
  originalPrice,
  tags,
  title,
  onClick: handleOnClick,
}) => {
  const imageSource = getImageUrl({
    source: imgSrc,
  })

  const leadingContent = (
    <Thumbnail
      alt={imgAlt}
      className={styles.itemRowImage}
      ratio={ThumbnailRatio.ratio1x1}
      size={size}
      src={imageSource}
    />
  )

  return (
    <ListItem
      className={styles.itemRowListItem}
      leadingContent={leadingContent}
      onClick={handleOnClick}
    >
      <div className={styles.itemRowBody}>
        <div className={styles.headerContainer}>
          <div className={styles.titleContainer}>
            <h2 className="pintxo-typography-body1">{title}</h2>
            {tags && <div className={styles.tagsContainer}>{tags}</div>}
          </div>
          <div className={styles.priceContainer}>
            <span className="pintxo-typography-body2">{price}</span>
            {originalPrice && (
              <span className={classNames(styles.originalPrice, 'pintxo-typography-caption')}>
                {originalPrice}
              </span>
            )}
          </div>
        </div>
        <p className={classNames('pintxo-typography-body2', styles.description)}>{description}</p>
      </div>
    </ListItem>
  )
}
